// Loan Financials — Fees ledger query-key factory (stale-after-save
// convention: queryKey arrays live only in *Keys files). The cross-loan key
// folds the filter params into the key; mutations invalidate by the bare
// ["portfolio-admin","fees"] prefix so every filtered variant refreshes.

import type {
  CrossLoanFeesParams,
  FeeReviewQueueParams,
} from "@/api/portfolioAdmin/loanFeesApi";

export const loanFeesKeys = {
  loan: (loanId: string) =>
    ["portfolio-admin", "loan", loanId, "fees"] as const,
  crossLoan: (params?: CrossLoanFeesParams) =>
    ["portfolio-admin", "fees", params ?? {}] as const,
  /** Prefix covering every filtered cross-loan variant — invalidate by this
   *  so all `crossLoan(params)` reads refresh. */
  crossLoanPrefix: () => ["portfolio-admin", "fees"] as const,
  // Revenue-pool options for the fee entry modal's optional pool tag. Read
  // gate (Claims.Read) differs from Loans.Read, so the modal treats a 403/
  // empty result as "no pools" — the tag stays optional and the fee saves
  // without one.
  poolOptions: () => ["portfolio-admin", "fees", "pool-options"] as const,
  // Fee Review queue (system-assessed fees pending B3 approve/waive). The
  // filter params fold into the key; mutations invalidate by the bare
  // prefix so every filtered variant refreshes.
  reviewQueue: (params?: FeeReviewQueueParams) =>
    ["portfolio-admin", "fee-review", params ?? {}] as const,
  reviewQueuePrefix: () => ["portfolio-admin", "fee-review"] as const,
  // Add Obligation wizard — the curated addable-type catalog + active WF1
  // ladder for one loan. Read-only registry/config data; nothing invalidates
  // it (a catalog change ships as code/config, not a staff mutation).
  obligationCatalog: (loanId: string) =>
    ["portfolio-admin", "loan", loanId, "obligation-catalog"] as const,
};
